import { Button } from "@/modern/components/ui/button-shadcn";
import { NotebookPen, Plus } from "lucide-react";

interface EmptyNotesStateProps {
  onCreateNote: () => void;
  loading: boolean;
}

export const EmptyNotesState = ({ onCreateNote, loading }: EmptyNotesStateProps) => (
  <div className="h-full flex items-center justify-center p-4 absolute inset-0">
    <div className="h-full flex flex-col items-center gap-6 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 px-8 py-8 text-center shadow-sm">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
        <NotebookPen className="size-6" />
      </div>
      <div className="space-y-2">
        <h3 className="text-base font-semibold text-foreground">Create your first note</h3>
        <p className="text-sm text-muted-foreground">Capture project updates, decisions, and ideas to keep your team aligned.</p>
      </div>
      <Button onClick={onCreateNote} disabled={loading} className="inline-flex items-center gap-2">
        <Plus className="size-4" />
        New note
      </Button>
    </div>
  </div>
);
